import React from 'react';
import './Modal.css'; // You'll need to create this CSS file for styling

const Modal = ({ isOpen, onClose, message }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>X</button>
                <p>{message}</p>
            </div>
        </div>
    );
};

export default Modal;
